import React, { useEffect, useRef, useState } from 'react';
import { isNumber, isString } from 'lodash';

import { SearchSvg } from '../../svg';

import { IInput } from './Input';
import {
  CustomIcon,
  ErrorIcon,
  InputText,
  Label,
  TickIcon,
  Tooltip,
  Wrapper,
} from './InputElements';

const Input = (props: IInput.IProps) => {
  const { onClearSearch, ...rest } = props;
  const [inputValue, setInputValue] = useState<string | number>('');
  useEffect(() => {
    if (props.value || isNumber(props.value)) {
      setInputValue(props.value);
    } else {
      setInputValue('');
    }
  }, [props.value]);

  return (
    <Wrapper marginWrapper={props.marginWrapper} style={props.style}>
      <InputText
        {...rest}
        value={inputValue}
        onChange={(v) => {
          if (!props.isNumber) {
            setInputValue(v.currentTarget.value);
            props.onChange ? props.onChange(v) : undefined;
          } else if (
            Number(v.currentTarget.value) ||
            v.currentTarget.value === '0' ||
            v.currentTarget.value === '.' ||
            v.currentTarget.value === ''
          ) {
            setInputValue(v.currentTarget.value);
            props.onChange
              ? props.onChange({
                  ...v,
                  // @ts-ignore
                  currentTarget: {
                    name: props.name || '',
                    value: v.currentTarget.value || '',
                  },
                })
              : undefined;
          }
        }}
        style={
          onClearSearch
            ? {
                paddingInline: 32,
              }
            : {}
        }
      />
      {props.isVerified && <TickIcon className={'icon-Check'} />}
      {props.hasError && <ErrorIcon className={'icon-alert-circle'} />}
      {props.hasError && <Tooltip>{props.errorMessage}</Tooltip>}
      {props.customIcon && <CustomIcon>{props.customIcon}</CustomIcon>}
      {!!onClearSearch && (
        <SearchSvg
          className={
            'tw-fill-gray300 tw-w-[14px] tw-h-[14px] tw-absolute tw-left-[12px] tw-bottom-[13px]'
          }
        />
      )}
      {((isString(inputValue) && inputValue.length > 0) || isNumber(inputValue)) &&
        !!onClearSearch && (
          <button
            onClick={() => {
              setInputValue('');
              onClearSearch();
            }}
            className={
              'icon-Close-Outline tw-absolute tw-right-[14px] tw-bottom-[14px] tw-text-[12px]'
            }
          />
        )}
      <Label hasError={props.hasError}>{props.label}</Label>
    </Wrapper>
  );
};

Input.defaultProps = {
  type: 'text',
  value: '',
  onChange: () => null,
  titleText: '',
  placeholder: '',
  hasError: false,
  errorMessage: '',
  isVerified: false,
  customIcon: null,
  marginWrapper: '',
};

export { Input };
